import { filterMap, selectPlaygroundFloor } from 'containers/Playground/playgroundSlice'
import { selectPlaceFilters, addFilters } from 'containers/MapDetails/placeSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React from 'react'

const usePlaceFilters = () => {
  const mapId = useReduxSelector(selectPlaygroundFloor)
  const filters = useReduxSelector(selectPlaceFilters)

  const dispatch = useReduxDispatch()
  const setFilters: React.Dispatch<React.SetStateAction<basic.Form>> = getState => {
    const state = typeof getState === 'function' ? getState(filters) : getState
    dispatch(addFilters({ filters: state }))
    dispatch(filterMap({ filters: state, mapId }))
  }

  return [
    filters,
    setFilters
  ] as const
}

export default usePlaceFilters